import type { ShopItemForBuyer } from "@/actions/shop";

/** Hard cap enforced by createShopOrderSchema (quantity.max(10)). */
export const SHOP_MAX_QUANTITY = 10;

/** Money in minor units to the viewer's localized currency string. */
export function formatMoney(minor: number, currency: string): string {
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(minor / 100);
}

/**
 * How many more units the viewer may buy right now, honoring the schema cap,
 * remaining stock, and the per-user limit (which counts what they already
 * hold). Returns 0 when the item can't be added to a fresh order.
 */
export function maxBuyableQuantity(item: ShopItemForBuyer): number {
  let max = SHOP_MAX_QUANTITY;
  if (item.remainingStock !== null) {
    max = Math.min(max, item.remainingStock);
  }
  if (item.maxPerUser !== null) {
    max = Math.min(max, Math.max(0, item.maxPerUser - item.purchasedByViewer));
  }
  return Math.max(0, max);
}
